import type { ChartAccount } from "@/lib/api";

// App setup subset of sylviq-accounting's generic chart. These three role
// codes must match the receipt and payable posting paths on the Worker.
export const STARTER_ACCOUNTS = [
  { code: "1100", name: "Cash and bank", account_type: "asset", sub_type: "cash" },
  { code: "1200", name: "Accounts receivable", account_type: "asset", sub_type: "accounts_receivable" },
  { code: "2100", name: "Accounts payable", account_type: "liability", sub_type: "accounts_payable" },
  { code: "3000", name: "Opening balance equity", account_type: "equity" },
  { code: "4000", name: "Sales revenue", account_type: "revenue" },
  { code: "5000", name: "Operating expenses", account_type: "expense" },
];

export function validateStarterChart(accounts: ChartAccount[]): void {
  for (const expected of STARTER_ACCOUNTS) {
    const existing = accounts.find((account) => account.code === expected.code);
    if (!existing) continue;
    const legacyReceivables =
      existing.code === "1100" &&
      existing.name.trim().toLowerCase() === "accounts receivable";
    if (
      legacyReceivables ||
      existing.account_type !== expected.account_type ||
      !existing.active
    ) {
      throw new Error(
        `Account ${expected.code} conflicts with the starter chart. Review your chart of accounts before continuing; existing accounts and postings will not be changed automatically.`,
      );
    }
  }
}
